import { useEffect } from 'react';
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';

/**
 * Anima un número de 0 al valor. `aria-live` para que lectores de pantalla
 * anuncien el valor final (mejora sobre el CountUp original, sin a11y).
 */
export function CountUp({ value, format }: { value: number; format: (n: number) => string }) {
  const mv = useMotionValue(0);
  const text = useTransform(mv, (v) => format(v));
  useEffect(() => {
    const controls = animate(mv, value, { duration: 0.9, ease: 'easeOut' });
    return () => controls.stop();
  }, [value, mv]);
  return (
    <motion.span role="status" aria-live="polite">
      {text}
    </motion.span>
  );
}
